
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Chat from '@/extend/classes/Chat';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeChat' })

export default class storeChat extends VuexModule {
  // States
  private reccords: Chat[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get chatLoading (): boolean {
    return this.dataLoading;
  }
  private get chatRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get chatLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewChat() {
    return (): Chat => { 
      return this.getChat(0, true);
    }
  }

  
  public get getChat () {
    return (id: number, canCreate = false): Chat => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Chat can't be 0")
        return new Chat();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Chat();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Chat.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromChat(data.reccords[0] as Chat);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listChat (): Chat[] {
    return this.reccords;
  }

  public get listConfigChat (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mChatRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mChatClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mChatLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mChatLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Chat.fromJson(reccord as Chat));
    })
    Chat.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mChatConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mChatCreated (obj: Chat): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareChat(obj)) {
          api.fromChat(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareChat(obj)) {
            api.fromChat(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mChatUpdated (obj: Chat): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareChat(obj)) {
          api.fromChat(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mChatDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerChat (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.chatRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerChat(this.chatCreated, this.chatUpdated, this.chatDeleted);
          this.mChatRegistered();
        } else {
          setTimeout(() => resolve(this.registerChat(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.chatLoading && !this.chatLoaded) {
          this.mChatLoading(true);
          return Chat.list(filter)
            .then((data: ListData) => {
              this.mChatLoaded(data);
              this.mChatLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredChat (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.chatLoading) {
        this.mChatLoading(true);
        return Chat.list(filter)
          .then((data: ListData) => {
            this.mChatLoaded(data);
            this.mChatLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createChat (obj: Chat): Promise<Chat> {
    return new Promise((resolve, reject) => {
      return Chat.fromJson(obj).createForStoreChat()
        .then((reccords) => {
          this.mChatCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateChat (obj: Chat): Promise<Chat> {
    return new Promise((resolve, reject) => {
      return Chat.fromJson(obj).updateForStoreChat()
        .then((reccords) => {
          this.mChatUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteChat (obj: Chat): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Chat.fromJson(obj).deleteForStoreChat()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mChatDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private chatCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mChatConfigUpdated(config)
    const obj = objConfig.obj as Chat;
    this.mChatCreated(Chat.fromJson(obj));
  }

  @Action
  private chatUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mChatConfigUpdated(config)
    const obj = objConfig.obj as Chat;
    this.mChatUpdated(Chat.fromJson(obj));
  }

  @Action
  private chatDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Chat;
    this.mChatDeleted(obj.id);
  }
}
